import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { DescriptionChip } from './DescriptionChip';

interface Props {
  subject: string;
  color: string;
  descriptions: {
    description: string;
    count: number;
  }[];
  onClick: (idx: number) => void;
}

export const IngredientDescriptionItem: FC<React.PropsWithChildren<Props>> = ({ subject, color, descriptions, onClick }) => {
  return (
    <Root>
      <Subject className={Typography.BODY_13_MEDIUM}>{subject}</Subject>
      <ChipList>
        {descriptions.map((item, idx) => (
          <DescriptionChip key={item.description} item={item} color={color} index={idx} onClick={onClick} />
        ))}
      </ChipList>
    </Root>
  );
};
const Root = styled.div`
  display: flex;
  align-items: baseline;
  padding: 12px 0;
`;

const Subject = styled.p`
  width: 61px;
  margin-right: 12px;
  color: ${vars.v3Color.gray500};
`;

const ChipList = styled.ul`
  flex: 1;
`;
